<template>
    <div class="limited-time-task-list">
        <div class="title">
            <span>{{ title }}</span>
        </div>

        <div class="desc">{{ desc }}</div>

        <div class="task-box-container">
            <task-box
                v-for="(task, index) in taskList"
                v-on="$listeners"
                :index="index"
                :task="task"
                :key="index"
                :class="{ 'mt-12': index !== 0 }"
            ></task-box>
        </div>
    </div>
</template>

<script>
import TaskBox from './TaskBox';
export default {
    components: {
        TaskBox
    },
    props: {
        rewardTaskInfo: {
            type: Object
        }
    },
    computed: {
        title() {
            return this.rewardTaskInfo.title || '';
        },
        desc() {
            return this.rewardTaskInfo.desc || '';
        },
        taskList() {
            return this.rewardTaskInfo.taskList || [];
        }
    }
};
</script>

<style lang="scss" scoped>
.limited-time-task-list {
    display: flex;
    flex-direction: column;
    text-align: center;
    padding: 18px 15px 15px;
    color: #002a3c;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0px 2px 6px 0px rgba(19, 66, 137, 0.1);
    .title {
        span {
            position: relative;
            font-size: 16px;
            font-weight: bold;
            &::before,
            &::after {
                content: '';
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                height: 2px;
                width: 15px;
                border-radius: 1px;
                background: #002a3c;
            }
            &::before {
                left: -22px;
            }
            &::after {
                right: -22px;
            }
        }
    }
    .desc {
        margin-top: 6px;
        font-size: 12px;
        font-weight: bold;
    }
    .task-box-container {
        margin-top: 15px;
        .mt-12 {
            margin-top: 12px;
        }
    }
}
</style>